
import React from "react"
import { Modal, Button } from "react-bootstrap"
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom"
import { formatDate } from "../../../../../utils/dateUtils"
import { useState } from "react"
import { useDispatch } from "react-redux";
import { stopPatientPrescriptionAction } from "../../../../../store/actions/PrescriptionAction";
import { getPatientPrescriptionsAction } from "../../../../../store/actions/PrescriptionAction"
import { handleSuccess, showErrorAlert } from "../../../../../services/ErrorHandlingService";

const PrescriptionHistoryModal = ({ show, onHide, prescriptionData, rawPrescriptions,handleViewClick,handleEditClick, patientDetails }) => {
  // Debug: Log the prescription data when modal opens
  const [confirmStop, setConfirmStop] = useState(null);
  const dispatch = useDispatch();
  React.useEffect(() => {
    if (show && prescriptionData) {
     

      prescriptionData.forEach((prescription, index) => {
        console.log(`Prescription ${index}:`, prescription)
        if (prescription.medicines && prescription.medicines.length > 0) {
          prescription.medicines.forEach((med, medIndex) => {
            console.log(`  Medicine ${medIndex}:`, {
              medicine_id: med.medicine_id,
              medicine_name: med.medicine_name,
              full_object: med,
            })
          })
        }
      })
    }
  }, [show, prescriptionData])

  const handleViewClickWithDebug = (prescription) => {
    if (prescription.medicines && prescription.medicines.length > 0) {
      prescription.medicines.forEach((med, index) => {
        console.log(`Medicine ${index} being passed:`, {
          medicine_id: med.medicine_id,
          medicine_name: med.medicine_name,
          full_object: med,
        })
      })
    }
    console.log("SELECTED PRESCRIPTION:", prescription)

    handleViewClick(prescription)
  }

  const handleEditPrescription = (prescription) => {
    console.log("EDIT PRESCRIPTION:", prescription);
  
    handleEditClick(prescription); // 🔥 CORRECT FUNCTION
  
    onHide();
  };
  

  return (
    <>
    <Modal show={show} 
    onHide={onHide} 
    centered size="lg"
       style={{ zIndex:10 }}>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Prescription History</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="card shadow-none">
          <div className="card-body">
            {prescriptionData.length > 0 ? (  
              prescriptionData.map((prescription, index) => (
<div
  className="mb-4 timeline-panel flex-wrap border-0 p-3 rounded position-relative"
  key={index}
  style={{
    backgroundColor: prescription.status === "Pending" ? "rgba(255, 255, 0, 0.3)" : "white",
    boxShadow: prescription.status !== "Pending" ? "0 4px 8px rgba(0, 0, 0, 0.2)" : "none",
  }}
>
{prescription.is_stop === "Yes" && (
  <span
    className="badge bg-danger"
    style={{
      position: "absolute",
      top: "10px",
      right: "10px",
      padding: "6px 10px",
      fontSize: "12px",
      borderRadius: "20px",
    }}
  >
    Stopped
  </span>
)}
                  <p className="fs-15 mb-0">
                    <strong>Prescribed By:</strong> {prescription.prescribed_by}
                  </p>
                  <p className="fs-15 mb-0">
                    {/* <strong>Date:</strong> {formatDate(prescription.created_at)} */}
                    <strong>Date:</strong> {formatDate(prescription.date)}
                  </p>
                  {/* <p className="fs-15 mb-0">
                    <strong>Diseases:</strong> {prescription.diseases || "None"}
                  </p> */}
                  <p className="fs-15 mb-0">
                    <strong>Status:</strong> {prescription.status || "-"}
                  </p>

               

                  <div className="d-flex justify-content-start mt-3">
                    <Link
                      to="#"
                      className="btn btn-primary btn-sm"
                      onClick={() => handleViewClickWithDebug(prescription)}
                    >
                      View
                    </Link>
                    <OverlayTrigger
  placement="top"
  overlay={
    <Tooltip>
      Cannot edit stopped prescription
    </Tooltip>
  }
>
  <span className="ms-2 d-inline-block">
    <Button
      variant="warning"
      size="sm"
      disabled={prescription.is_stop === "Yes"}
    >
      Edit
    </Button>
  </span>
</OverlayTrigger>
  {prescription.status === "PENDING" &&
 prescription.is_stop === "No" && (
  <Button
    variant="danger"
    size="sm"
    className="ms-2"
    onClick={() => setConfirmStop(prescription)}
  >
    Stop Prescription
  </Button>
)}
</div>

                </div>
              ))
            ) : (
              <div className="text-center text-muted">No prescription history found</div>
            )}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
    <Modal show={!!confirmStop} centered onHide={() => setConfirmStop(null)}>
        <Modal.Header closeButton>
          <Modal.Title>Stop Prescription</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to stop this ongoing prescription?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setConfirmStop(null)}>
            No
          </Button>
          <Button
  variant="danger"
  onClick={async () => {
    console.log("confirmStop object:", confirmStop);

    const prescriptionId =
    confirmStop?.prescription_id || confirmStop?.prescriptionId;
  
  const patientId =
    confirmStop?.patient_id || confirmStop?.patientId;
  
  if (!prescriptionId) {
    showErrorAlert("Prescription ID missing");
    return;
  }
  
  const result = await dispatch(
    stopPatientPrescriptionAction(prescriptionId)
  );
  
  if (result?.success) {
    handleSuccess("Prescription stopped successfully");
  
    await dispatch(
      getPatientPrescriptionsAction({
        patient_id: patientId 
      })
    );
  
    setConfirmStop(null);
  }
  }}
>
  Yes, Stop
</Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default PrescriptionHistoryModal;


// import React from "react"
// import { Modal, Button } from "react-bootstrap"
// import { Link } from "react-router-dom"
// import { formatDate } from "../../../../../utils/dateUtils"

// const PrescriptionHistoryModal = ({ show, onHide, prescriptionData, handleViewClick }) => {
  
//   const [localData, setLocalData] = React.useState([]);
//   const [confirmStop, setConfirmStop] = React.useState(null);

//   // Load incoming prescriptionData into local state
//   React.useEffect(() => {
//     if (show && Array.isArray(prescriptionData)) {
//       setLocalData([...prescriptionData]);
//     }
//   }, [show, prescriptionData]);

//   const handleViewClickWithDebug = (prescription) => {
//     handleViewClick(prescription)
//   };

//   // STOP PRESCRIPTION - Local only
//   const stopPrescription = () => {
//     if (!confirmStop) return;

//     const updated = localData.map((item) =>
//       item._id === confirmStop._id
//         ? { ...item, status: "Stopped" }
//         : item
//     );

//     setLocalData(updated);
//     setConfirmStop(null);
//   };

//   return (
//     <>
//       {/* Main Modal */}
//       <Modal show={show} onHide={onHide} centered size="lg">
//         <Modal.Header closeButton>
//           <Modal.Title>Prescription History</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="card shadow-none">
//             <div className="card-body">
//               {localData.length > 0 ? (
//                 localData.map((prescription, index) => (
//                   <div
//                     className="mb-4 timeline-panel flex-wrap border-0 p-3 rounded"
//                     key={index}
//                     style={{
//                       backgroundColor: prescription.status === "Pending"
//                         ? "rgba(255, 255, 0, 0.3)"
//                         : "white",
//                       boxShadow: prescription.status !== "Pending"
//                         ? "0 4px 8px rgba(0, 0, 0, 0.2)"
//                         : "none",
//                     }}
//                   >
//                     <p className="fs-15 mb-0"><strong>Prescribed By:</strong> {prescription.prescribed_by}</p>
//                     <p className="fs-15 mb-0"><strong>Date:</strong> {formatDate(prescription.date)}</p>
//                     <p className="fs-15 mb-0"><strong>Status:</strong> {prescription.status || "-"}</p>

//                     <div className="d-flex gap-2 mt-3">
//                       {/* VIEW BUTTON */}
//                       <Link
//                         to="#"
//                         className="btn btn-primary btn-sm"
//                         onClick={() => handleViewClickWithDebug(prescription)}
//                       >
//                         View
//                       </Link>

//                       {/* STOP BUTTON - only if Active/Ongoing */}
//                       {(prescription.status === "Active" ||
//                         prescription.status === "Ongoing") && (
//                         <Button
//                           variant="danger"
//                           size="sm"
//                           onClick={() => setConfirmStop(prescription)}
//                         >
//                           Stop Prescription
//                         </Button>
//                       )}
//                     </div>
//                   </div>
//                 ))
//               ) : (
//                 <div className="text-center text-muted">No prescription history found</div>
//               )}
//             </div>
//           </div>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button onClick={onHide}>Close</Button>
//         </Modal.Footer>
//       </Modal>

//       {/* CONFIRM STOP MODAL */}
//       <Modal show={!!confirmStop} centered onHide={() => setConfirmStop(null)}>
//         <Modal.Header closeButton>
//           <Modal.Title>Stop Prescription</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           Are you sure you want to stop this ongoing prescription?
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setConfirmStop(null)}>
//             Cancel
//           </Button>
//           <Button variant="danger" onClick={stopPrescription}>
//             Yes, Stop
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </>
//   );
// };

// export default PrescriptionHistoryModal;
